import React, { useRef, createElement } from 'react';
import { Favicon } from './Favicon';
import { SocialPreview } from './SocialPreview';
// SVG source as a string (must match Favicon.tsx exactly)
const FAVICON_SVG = `<svg width="512" height="512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><rect width="512" height="512" rx="96" fill="#0a0a0a"/><rect x="80" y="408" width="352" height="24" rx="12" fill="#d4a853"/><path d="M 112 376 L 112 136 L 176 136 L 256 280 L 336 136 L 400 136 L 400 376 L 344 376 L 344 232 L 280 344 L 232 344 L 168 232 L 168 376 Z" fill="#f5f5f0"/></svg>`;
function triggerDownload(blobUrl: string, filename: string) {
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
function downloadSVG() {
  const blob = new Blob([FAVICON_SVG], {
    type: 'image/svg+xml'
  });
  const url = URL.createObjectURL(blob);
  triggerDownload(url, 'favicon.svg');
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
function downloadPNG(size: number) {
  const svgBlob = new Blob([FAVICON_SVG], {
    type: 'image/svg+xml;charset=utf-8'
  });
  const svgUrl = URL.createObjectURL(svgBlob);
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(img, 0, 0, size, size);
    canvas.toBlob(blob => {
      if (!blob) return;
      const pngUrl = URL.createObjectURL(blob);
      triggerDownload(pngUrl, `favicon-${size}x${size}.png`);
      setTimeout(() => URL.revokeObjectURL(pngUrl), 1000);
    }, 'image/png');
    URL.revokeObjectURL(svgUrl);
  };
  img.src = svgUrl;
}
function downloadSocialPreview() {
  const node = document.getElementById('social-preview-export');
  if (!node) return;
  alert('For the social preview, please right-click the image below and select "Save image as…" or take a screenshot. (PNG export from HTML requires an external library.)');
}
export function BrandAssets() {
  return <div className="min-h-screen bg-offwhite-50 py-16 px-6 md:px-12" data-id="element-110" data-mp="se660ti54ykl">
      <div className="max-w-5xl mx-auto" data-id="element-111" data-mp="nnpqn3urf2vl">
        <header className="mb-12" data-id="element-112" data-mp="nmeo17d1w162">
          <h1 className="text-4xl font-bold text-charcoal-950 mb-3" data-id="element-113" data-mp="nlmq3pvzdrcm">
            Brand Assets
          </h1>
          <p className="text-charcoal-800 text-lg max-w-2xl" data-id="element-114" data-mp="ims82q5u86tk">
            Click the download buttons below to grab the files you need for
            Publish.
          </p>
        </header>

        {/* Favicon section */}
        <section className="mb-16 bg-white rounded-3xl p-10 border border-offwhite-200 shadow-sm" data-id="element-115" data-mp="4obssatwt7zt">
          <h2 className="text-2xl font-bold text-charcoal-950 mb-2" data-id="element-116" data-mp="3vvobwvecrvid">Favicon</h2>
          <p className="text-charcoal-800 mb-8" data-id="element-117" data-mp="1z2uuwcajh9hb">
            Bold "M" with amber accent on charcoal. Stays crisp at every size.
          </p>

          {/* Size previews */}
          <div className="flex flex-wrap items-end gap-10 mb-10" data-id="element-118" data-mp="1u4l2uak42ozx">
            <div data-id="element-119" data-mp="21m9gwbyhb0q2">
              <div className="rounded-2xl overflow-hidden shadow-lg" style={{
              width: 128,
              height: 128
            }} data-id="element-120" data-mp="21mrhfks6c13s">
                <div style={{
                transform: 'scale(0.25)',
                transformOrigin: 'top left',
                width: 512,
                height: 512
              }} data-id="element-121" data-mp="2bdvwsllrhnz5">
                  <Favicon data-id="element-122" data-mp="1nmzx72b2dohc" />
                </div>
              </div>
              <p className="text-xs text-charcoal-500 mt-3 font-mono" data-id="element-123" data-mp="1npcpo9eg7h8n">128px</p>
            </div>
            <div data-id="element-124" data-mp="1soz3ajy6uzhz">
              <div className="rounded-xl overflow-hidden shadow-md" style={{
              width: 64,
              height: 64
            }} data-id="element-125" data-mp="1xlfqnbxkd9u0">
                <div style={{
                transform: 'scale(0.125)',
                transformOrigin: 'top left',
                width: 512,
                height: 512
              }} data-id="element-126" data-mp="390maqntngwdx">
                  <Favicon data-id="element-127" data-mp="32m6z99839nxx" />
                </div>
              </div>
              <p className="text-xs text-charcoal-500 mt-3 font-mono" data-id="element-128" data-mp="3gkne5ng3ukr5">64px</p>
            </div>
            <div data-id="element-129" data-mp="3bl11pg83p8je">
              <div className="rounded-md overflow-hidden shadow-sm" style={{
              width: 32,
              height: 32
            }} data-id="element-130" data-mp="3bkiwhu3gnjzc">
                <div style={{
                transform: 'scale(0.0625)',
                transformOrigin: 'top left',
                width: 512,
                height: 512
              }} data-id="element-131" data-mp="3lioyebp9oq47">
                  <Favicon data-id="element-132" data-mp="d3ogubnnkzuq" />
                </div>
              </div>
              <p className="text-xs text-charcoal-500 mt-3 font-mono" data-id="element-133" data-mp="d3ws5z44nx3t">
                32px (browser tab)
              </p>
            </div>
          </div>

          {/* Download buttons */}
          <div className="flex flex-wrap gap-3" data-id="element-134" data-mp="rr597gk4awnp">
            <button onClick={() => downloadPNG(32)} className="bg-amber-500 hover:bg-amber-400 text-charcoal-950 px-6 py-3 rounded-full font-bold transition-all" data-id="element-135" data-mp="vsh1xuyafy04">
              Download 32×32 PNG
            </button>
            <button onClick={() => downloadPNG(64)} className="bg-charcoal-950 hover:bg-charcoal-800 text-white px-6 py-3 rounded-full font-bold transition-all" data-id="element-136" data-mp="mtdigpv7lgl3">
              Download 64×64 PNG
            </button>
            <button onClick={() => downloadPNG(180)} className="bg-charcoal-950 hover:bg-charcoal-800 text-white px-6 py-3 rounded-full font-bold transition-all" data-id="element-137" data-mp="3v7vmmgi14bzf">
              Download 180×180 PNG (Apple Touch)
            </button>
            <button onClick={() => downloadPNG(512)} className="bg-charcoal-950 hover:bg-charcoal-800 text-white px-6 py-3 rounded-full font-bold transition-all" data-id="element-138" data-mp="3q7q0tgyfxjp9">
              Download 512×512 PNG
            </button>
            <button onClick={downloadSVG} className="bg-white hover:bg-offwhite-100 text-charcoal-950 border-2 border-charcoal-950 px-6 py-3 rounded-full font-bold transition-all" data-id="element-139" data-mp="32bcxwxy5givx">
              Download SVG
            </button>
          </div>
          <p className="text-sm text-charcoal-500 mt-4" data-id="element-140" data-mp="3q1qensbaavb7">
            Most upload fields accept the 32×32 PNG. If you want every size
            (iOS, Android, etc.), drop the SVG into{' '}
            <a href="https://realfavicongenerator.net" target="_blank" rel="noopener noreferrer" className="text-amber-600 underline" data-id="element-141" data-mp="3g2reyz8hya0c">
              realfavicongenerator.net
            </a>
            .
          </p>
        </section>

        {/* Social Preview section */}
        <section className="mb-16 bg-white rounded-3xl p-10 border border-offwhite-200 shadow-sm" data-id="element-142" data-mp="1zs5lb7lfrdpt">
          <h2 className="text-2xl font-bold text-charcoal-950 mb-2" data-id="element-143" data-mp="f5xhgoxpso24">
            Social Preview Image
          </h2>
          <p className="text-charcoal-800 mb-8" data-id="element-144" data-mp="p67tw7bxdrg8">
            1200×630 card shown when your site is shared on social platforms.
            Right-click the image below and "Save image as…" to download.
          </p>

          <div id="social-preview-export" className="rounded-2xl overflow-hidden shadow-xl inline-block" data-id="element-145" data-mp="ywj0k1mzueqt">
            <SocialPreview data-id="element-146" data-mp="12vjh1di015an" />
          </div>

          <p className="text-sm text-charcoal-500 mt-6" data-id="element-147" data-mp="17vxpgwniih97">
            Tip: if "Save image as…" doesn't work cleanly, take a screenshot at
            full zoom — the image is rendered at exactly 1200×630.
          </p>
        </section>

        {/* Next steps */}
        <section className="bg-charcoal-950 text-offwhite-100 rounded-3xl p-10" data-id="element-148" data-mp="39px15j4jr0mf">
          <h2 className="text-2xl font-bold mb-4" data-id="element-149" data-mp="3enf7r2v3d3r9">Next steps</h2>
          <ol className="space-y-3 text-offwhite-200 list-decimal list-inside" data-id="element-150" data-mp="1ke9rfautatpc">
            <li data-id="element-151" data-mp="1fg88cpxdyudv">Download the favicon PNG (32×32 is the standard).</li>
            <li data-id="element-152" data-mp="1fdvv2q2kp875">
              Save the social preview image (right-click → Save image as).
            </li>
            <li data-id="element-153" data-mp="1u6pakbhuhobt">
              Click <strong data-id="element-154" data-mp="1p58c0mmu2dye">Publish</strong> in the top right of Magic Patterns
              and upload both files in their respective fields.
            </li>
          </ol>
        </section>
      </div>
    </div>;
}